import * as actionTypes from 'src/actions';

const initialState = {
    loading: false,
    loggedIn: false,
    token: {},
    user: {},
    selectedVendorId: 0
};

const sessionReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SESSION_LOGIN_REQUEST:
            return { loading: true };
        case actionTypes.SESSION_LOGIN_SUCCESS: {
            return {
                ...initialState,
                loggedIn: true
            };
        }
        case actionTypes.SESSION_SET_TOKEN: {
            return {
                ...initialState,
                token: action.payload
            };
        }
        case actionTypes.SESSION_LOGIN_FAIL:
            return { loading: false, error: action.payload };
        case actionTypes.SESSION_LOGOUT: {
            return {
                ...state,
                loggedIn: false,
                user: {
                    role: 'GUEST'
                }
            };
        }
        case actionTypes.SESSION_CREDENTIALS: {
            return {
                ...state,
                user: action.payload
            };
        }
        case actionTypes.SESSION_SET_VENDOR_ID:
            return {
                ...state,
                selectedVendorId: action.payload
            };
        default:
            return state;
    }
};

export default sessionReducer;
